import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';

import { ProgressIndicatorComponent } from './progress-indicator.component';

@NgModule({
  declarations: [ProgressIndicatorComponent],
  imports: [CommonModule],
  exports: [ProgressIndicatorComponent],
})
export class ProgressIndicatorModule {
  constructor() {
    const animations = inject(ANIMATION_MODULE_TYPE, { optional: true });

    if (!animations) {
      throw new Error('You need to import the BrowserAnimationsModule or NoopAnimationsModule in your application!');
    }
  }
}
